<template>
  <div class="login-layout">
    <div class="login-container">


      <!--PASSWORD RESET-->
      <Card class="login-card password-card">
        <div align="center" class="mb-30">
          <img src="/static/img/logo.png" alt="" style="width: 115px">
        </div>


        <div>
          <h1 class="login-header">Восстановление пароля</h1>
          <div style="min-height: 200px;">

            <Form
              v-if="password_reset_step_1"
              ref="formDataReset"
              :model="formDataReset"
              :rules="rules"
              @keydown.enter.native="resetPass()"
            >
              <FormItem prop="phone">
                <Label>Введите номер телефона, и мы вышлем код для сброса пароля</Label>
                <Input
                  class="border_30"
                  type="text"
                  v-model="formDataReset.phone"
                  placeholder="+7(___)___-__-__"
                  size="large"
                  v-mask="'+7(###) ###-##-##'"
                >
                </Input>
              </FormItem>


              <Button
                type="info"
                @click="resetPass()"
                size="large"
                :disabled="!validFormReset"
              >
                Получить код
              </Button>


              <div class="options-box">
                <router-link to="/login" class="options-box__item">Войти в систему</router-link>
                <router-link to="/login/register" class="options-box__item">Регистрация</router-link>
              </div>
              <Spin size="large" fix v-if="loading"></Spin>
            </Form>


            <Form v-if="password_reset_step_2"
                  @keydown.enter.native="checkCode()">

              <Label>Введите код из SMS-сообщения</Label>
              <Input
                class="border_30"
                type="text"
                v-model="enterCode"
                placeholder="****"
                size="large"
              >
              </Input>


              <div class="timer-box">

                <div class="d-flex">
                  <span>Осталось: </span>
                  <div style="padding: 0 3px">{{(time.h)?(time.h)+':':''}}{{(time.m > 9)?time.m:'0'+time.m}}:{{(time.s >
                    9)?time.s:'0'+time.s}}
                  </div>
                  <span> секунд</span>
                </div>


                <Button :disabled="!repeatCode" @click="resetPass()">отправить код повторно</Button>
              </div>


              <Button
                type="info"
                @click="checkCode()"
                size="large"
                :disabled="!enterCode"
              >
                Подтвердить
              </Button>


              <div class="options-box">
                <router-link to="/login" class="options-box__item">Войти в систему</router-link>
                <router-link to="/login/register" class="options-box__item">Регистрация</router-link>
              </div>
              <Spin size="large" fix v-if="loading"></Spin>
            </Form>


            <Form v-if="password_reset_step_3"
                  ref="formDataUpdate"
                  :rules="rules"
                  :model="formDataUpdate"
                  @keydown.enter.native="updatePass()">


              <FormItem prop="password">
                <label>Придумайте новый пароль</label>
                <Input
                  class="border_30"
                  type="password"
                  v-model="formDataUpdate.password"
                  placeholder="Новый пароль"
                  size="large"
                >
                </Input>
              </FormItem>

              <FormItem prop="password_check">
                <Input
                  class="border_30"
                  type="password"
                  v-model="formDataUpdate.password_check"
                  placeholder="Подтвердите пароль"
                  size="large"
                >
                </Input>
              </FormItem>


              <Button
                type="info"
                @click="updatePass()"
                size="large"
                :disabled="!validFormUpdate"
              >
                Восстановить
              </Button>


              <div class="options-box">
                <router-link to="/login" class="options-box__item">Войти в систему</router-link>
                <router-link to="/login/register" class="options-box__item">Регистрация</router-link>
              </div>
              <Spin size="large" fix v-if="loading"></Spin>
            </Form>


          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>

    import {server_addr, login_addr} from "../../http";
    import {mask} from "vue-the-mask";
    import {formatErrorMsg} from "@/base/base_func.js";

    export default {
        name: "reset",
        directives: {
            mask
        },

        data() {

          const validatePass = (rule, value, callback) => {
              if (value === '') {
                callback(new Error('Пожалуйста, введите пароль'));
              } else if (value.length < 5 || value.length > 30) {
                callback(new Error("Длина пароля от 5 до 30 символов"));
              } else {
                if (this.formDataUpdate.password_check !== '') {
                  this.$refs.formDataUpdate.validateField('password_check');
                }
                callback();
              }
          };
          const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
              callback(new Error('Пожалуйста, введите пароль'));
            } else if (value.length < 5 || value.length > 30) {
              callback(new Error("Длина пароля от 5 до 30 символов"));
            } else if (value !== this.formDataUpdate.password) {
              callback(new Error('Пароли должны совпадать'));
            } else {
              callback();
            }
          };

            return {

                validForm: false,
                validFormReset: false,
                validFormUpdate: false,

                password_reset_step_1: true,
                password_reset_step_2: false,
                password_reset_step_3: false,

                choiceUrl: false,
                formatNum: '',


                formDataReset: {
                    phone: "+7"
                },
                formDataUpdate: {
                    password: '',
                    password_check: ''
                },
                enterCode: '',

                passwordReset__token: null,

                rules: {
                    username: [
                        {
                            required: true,
                            message: "Пожалуйста, введите имя пользователя",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 17,
                            message: "Недостаточно символов",
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: "Пожалуйста, введите имя пользователя",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 17,
                            message: "Недостаточно символов",
                            trigger: "blur"
                        }
                    ],
                    password: [
                        // {
                        //     required: true,
                        //     message: "Пожалуйста, введите пароль",
                        //     trigger: "change"
                        // },
                        // {
                        //     type: "string",
                        //     min: 5,
                        //     max: 30,
                        //     message: "Длина пароля от 5 до 30 символов",
                        //     trigger: "change"
                        // },
                        {
                          validator: validatePass,
                          trigger: 'blur'
                        }
                    ],
                    password_new: [
                        {
                            required: true,
                            message: "Пожалуйста, введите пароль",
                            trigger: "blur"
                        },
                        {
                            type: "string",
                            min: 5,
                            max: 30,
                            message: "Длина пароля от 5 до 30 символов",
                            trigger: "blur"
                        }
                    ],
                    password_check: [
                        // {
                        //     required: true,
                        //     message: "Пожалуйста, введите пароль",
                        //     trigger: "blur"
                        // },
                        // {
                        //     type: "string",
                        //     min: 5,
                        //     max: 30,
                        //     message: "Длина пароля от 5 до 30 символов",
                        //     trigger: "blur"
                        // },
                      {
                        validator: validatePassCheck,
                        trigger: 'blur'
                      }
                    ],

                },

                repeatCode: false,
                time: {m: 4, s: 59, ms: 0},
                timeOn: true,
                count: null,

                loading: false
            };
        },
        watch: {
            "formData.username": function (val, oldVal) {
                // this.blockSubmit = !this.validForm();
                this.isValidForm();
            },
            "formData.password": function (val, oldVal) {
                this.isValidForm();
            },
            "formDataReset.phone": function (val, oldVal) {
                this.isValidFormReset();
            },
            "formDataUpdate.password": function (val, oldVal) {
                this.isValidFormUpdate();
            },
            "formDataUpdate.password_check": function (val, oldVal) {
                this.isValidFormUpdate();
            }
        },

        computed: {
            username() {
                return this.formData.username.replace(/^\+7/, "").replace(/\D/g, "");
            },
            password() {
                return this.formData.password;
            },
            handledData() {
                return {
                    username: this.username,
                    password: this.password,
                    grant_type: "password"
                };
            },

        },


        methods: {
            ping: function () {
                if (this.timeOn) {
                    if (++this.time.ms > 9) {
                        this.time.ms = 0;
                        this.time.s--;
                    }
                    if (this.time.s < 0) {
                        this.time.s = 59;
                        this.time.m--;
                    }
                    if (this.time.m === 0 && this.time.s === 0) {
                        this.timeOn = false;
                        this.repeatCode = true;
                        clearTimeout(this.count);
                    }
                }
            },


            isValidForm() {
                this.$refs.formData.validate(valid => {
                    this.validForm = valid;
                });
            },

            isValidFormReset() {
                this.$refs.formDataReset.validate(valid => {
                    this.validFormReset = valid;
                });
            },
            isValidFormUpdate() {
                this.$refs.formDataUpdate.validate(valid => {
                    // if (this.formDataUpdate.password === this.formDataUpdate.password_check) {
                    this.validFormUpdate = valid;
                    // } else {
                    //     this.validFormUpdate = false;
                    // }
                });
            },


            resetPass() {
                this.loading = true;
                const url = login_addr + '/wcadmin/v1/secretMessages';

                var num = this.formDataReset.phone.split('');
                this.formatNum = num[3] + num[4] + num[5] + num[8] + num[9] + num[10] + num[12] + num[13] + num[15] + num[16];


                this.$http
                    .post(url, {
                        "phone": this.formatNum
                    })
                    .then(response => {
                        this.password_reset_step_1 = false;
                        this.password_reset_step_2 = true;
                        this.time = {m: 4, s: 59, ms: 0};
                        this.repeatCode = false;
                        this.timeOn = true;
                        this.count = setInterval(this.ping, 100);
                    })
                    .catch(error => {
                      if (error.response.status === 400) {
                        // this.$Message.error("Неверное имя пользователя или пароль");
                        // this.$Message.error("Для работы с Товароучетной системой обратитесь в поддержку Light Kassa");
                        this.$Message.error("Неверный код из СМС, который пришел на Ваш телефон");
                      } else {
                        this.$Message.error("Ошибка");
                      }
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    // .catch(error => {
                    //     this.$Notice.open({
                    //         title: 'Ошибка',
                    //         desc: 'Такого пользователя не существует'
                    //     });
                    //
                    // })
            },

            checkCode() {
                this.loading = true;
                const url = login_addr + '/wcadmin/v1/passwordTokens?userId=' + this.formatNum + '&secret=' + this.enterCode;

                this.$http
                    .get(url)
                    .then(response => {
                        this.password_reset_step_2 = false;
                        this.password_reset_step_3 = true;
                        this.passwordReset__token = response.data.token;
                    })
                    .finally(() => {
                        this.loading = false;
                    })
                    // .catch(error => {
                    //     this.$Notice.open({
                    //         title: 'Ошибка',
                    //         desc: 'Неверный SMS-код'
                    //     });
                    // })
            },
            updatePass() {
                this.loading = true;
                const url = login_addr + '/wcadmin/v1/changeForgottenPassword?token=' + this.passwordReset__token + '&password=' + this.formDataUpdate.password;

                this.$http
                    .post(url)
                    .then(response => {
                        this.$Notice.open({
                            title: 'Уведомление',
                            desc: 'Пароль успешно обновлен'
                        });
                    })
                    .finally(() => {
                        this.loading = false;
                        this.$router.push({name: "login"})
                    })
                    // .catch(error => {
                    //     this.$Notice.open({
                    //         title: 'Ошибка',
                    //         desc: 'Произошла ошибка. Обратитесь в службу поддержки'
                    //     });
                    // })
            }
        }
    };
</script>


<style scoped>
  .login-layout {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    box-sizing: border-box;
    background-color: #ebebeb;
  }

  .login-container {
    background: url("/static/img/bg-login.d56f2ef7.png") right center;
    background-size: cover;
    width: 100%;
    min-height: 100vh;
    display: -webkit-box;
    display: -webkit-flex;
    display: -moz-box;
    display: -ms-flexbox;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    padding: 15px;
    margin: 0;
    box-sizing: border-box;

  }

  .login-header {
    text-align: center;
    margin-bottom: 30px;
  }

  .login-card {
    width: 600px;
    background: #fff;
    border-radius: 25px;
    position: relative;
    padding: 20px;
    margin-left: 10%;
  }

  .options-box {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .options-box .options-box__item {
    padding: 0 12px;
    color: #5087DE;
    text-decoration: underline;
    font-weight: 600;
  }

  .options-box .options-box__item:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  .options-box .options-box__item:nth-child(2) {
    border-left: 1px solid #5087DE;
  }

  .enter-card {
    border-radius: 25px;
    text-transform: uppercase;
    margin-bottom: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.25);
    display: block;
    padding: 20px;
  }

  .enter-card:hover {
    background: #5087DE;
  }

  .enter-card:hover h3 {
    color: #ffffff;
  }

  .enter-card img {
    max-width: 100%;
  }

  label.ivu-form-item-label, label {
    color: #acacac;
    font-size: 15px;
    margin-bottom: 5px;
    display: block;
  }

  input.ivu-input, textarea.ivu-input, .ivu-input-number {
    border-radius: 24px;
  }

  button {
    width: 300px;
    margin: 40px auto 24px auto;
    display: block;
    border-radius: 24px;
  }

  .timer-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 12px;
    color: #acacac;
  }

  .timer-box button {
    width: auto;
    margin: 0;
    background: transparent;
    border: none;
    box-shadow: none;
    padding: 5px;
    color: #5087DE;
    text-decoration: underline;
    border-radius: 0;
  }

  .timer-box button[disabled="disabled"] {
    color: #acacac;
  }

  @media screen and (max-width: 767px) {
    .login-card {
      width: 90%;
      margin: 0 auto;
    }
  }

  @media screen and (max-width: 400px) {
    .login-card {
      width: 95%;
      padding: 12px;
    }

  }

</style>

<style>
  .login-layout .ivu-input-group-prepend {
    background-color: transparent;
    border: none;
  }

  .login-layout .ivu-input-group-with-prepend .ivu-input {
    border-top-left-radius: 18px;
    border-bottom-left-radius: 18px;
  }


  @media screen and (max-width: 400px) {

    .ivu-form-item-content .ivu-form-item-error-tip {
      font-size: 10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/apps/login/reset.vue